// Share links for things that carry a slug — leagues at /l/{slug},
// tournaments at /t/{slug}, and the same shape for anything added later.

/**
 * The origin a copied link should point at.
 *
 * The real one in a browser, so a link copied from a staging host stays on that
 * host; production only as the fallback for anywhere there is no window.
 */
export const SHARE_ORIGIN =
  (typeof window !== 'undefined' && window.location && window.location.origin)
  || 'https://app.torchvolleyball.com';

/**
 * Copy text, reporting whether it worked.
 *
 * The clipboard API is unavailable outside a secure context and blocked
 * outright in some browsers, and it fails by rejecting rather than by doing
 * nothing visible — so the caller needs the answer. A copy that silently did
 * not happen is worse than one that says so and shows you the link.
 */
export async function copyText(text) {
  try {
    if (!navigator.clipboard) return false;
    await navigator.clipboard.writeText(text);
    return true;
  } catch (e) {
    return false;
  }
}
